import { h } from '@omni-torn/ui';
import { TERMS_HISTORY, TERMS_VERSION, termsAnchor, TORN_TERMS } from '@omni-torn/shared';
import { session } from '../session';
import { box } from '../ui';
import { termsFullTable } from './keys';

/**
 * /terms — Omni-Torn's full terms, for everyone: no sign-in needed. Everywhere else (the extension, Torn PDA, the website's
 * sign-in and Account, the Discord bot) shows Torn's table short — Torn's answers, a one-sentence summary and "Read more"
 * per row — and links here (owner's calls 2026-10-31). Here: what's new in this version, the short summaries with a jump
 * to each row, Torn's table whole and word for word (each row its anchor: #data-storage …), every earlier version
 * (#v1 … #vN) and the privacy policy.
 */
export function renderTerms(view: HTMLElement): void {
  document.title = 'Terms · Omni-Torn';
  const now = TERMS_HISTORY[0]!;
  view.replaceChildren(
    box(
      `What’s new in version ${now.version}`,
      [
        h('p', { class: 'terms-new' }, now.what),
        h('p', { class: 'muted' }, `${now.date}. Something new is kept or shared only once you agreed to the version that says it. `, h('a', { href: '#earlier' }, 'Every earlier version'), ' · ', h('a', { href: '/privacy.html' }, 'Privacy policy')),
      ],
      { id: 'terms-new', cls: 'terms-new-box' },
    ),
    box(
      'In short',
      [
        h('ul', { class: 'plain-list terms-summaries' }, ...TORN_TERMS.map((r) => h('li', {}, h('a', { href: `#${termsAnchor(r.name)}` }, h('strong', {}, r.name)), ': ', r.summary))),
      ],
      { id: 'terms-short' },
    ),
    box(
      'What Omni-Torn does with your key (Torn’s API terms)',
      [
        h('p', { class: 'terms-version' }, h('strong', {}, `Terms version ${TERMS_VERSION}`), ' — the same for the website, the extension, Torn PDA and the Discord bot: a key given in one is used by the others, for the uses you pick.'),
        h('p', { class: 'muted' }, 'Torn asks every tool that keeps keys or data to show this table where a key is given. Each row: Torn’s own answers in bold, then what exactly, in plain words.'),
        termsFullTable(true),
      ],
      { id: 'terms' },
    ),
    box(
      h('span', { id: 'earlier' }, 'Earlier versions'),
      [
        h('p', { class: 'muted' }, 'What each version added. Something new is shared only once you agreed to the version that says it.'),
        h('ul', { class: 'plain-list terms-history' }, ...TERMS_HISTORY.map((v) => h('li', { id: `v${v.version}`, 'data-version': String(v.version) }, h('a', { href: `#v${v.version}`, class: 'terms-v' }, h('strong', {}, `Version ${v.version}`)), ` (${v.date})${v.version === TERMS_VERSION ? ', now' : ''}: `, v.what))),
        h('p', {}, h('a', { href: '/privacy.html' }, 'Privacy policy'), ' · ', session.get() ? h('a', { href: '/account', 'data-link': true }, 'Your account') : h('a', { href: '/', 'data-link': true }, 'Sign in')),
      ],
      { id: 'terms-history' },
    ),
  );
  // Opened at a row or a version (/terms#data-sharing, /terms#v9 — "Read more" links): the page is drawn after the browser
  // looked for the anchor, so go there now.
  const id = decodeURIComponent(location.hash.slice(1));
  if (id) document.getElementById(id)?.scrollIntoView();
}
